import { render, staticRenderFns } from "./zizhu.vue?vue&type=template&id=98da2c1c"
import script from "./zizhu.vue?vue&type=script&lang=js"
export * from "./zizhu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports